export default {
sets: `Uppsättningar`,
stats: `Statistik`,
discover: `Upptäck`,
guides: `Guider`,
settings: `inställningar`,
unsupportedBrowserBody: `Flashcards stöder inte denna webbläsare. Ladda ner den senaste versionen av Chrome eller Opera, eller ladda ner vår iPhone- eller Android -applikation`,
unsupportedBrowserTitle: `Webbläsare som inte stöds`,
noData: `Inga data att visa`,
contactUsTitle: `Vi älskar att höra hur våra användare använder vår app och hur vi kan förbättra. Släpp oss ett meddelande med alla frågor, till exempel funktionsförfrågningar, eller felrapporter`,
rateAppStore: `Betyg i Appstore`,
rateGoogle: `Betyg i Google Play`,
close: `Stänga`,
shareFriends: `Dela med vänner`,
noCardsQ: `Har du inga flashcards?`,
noCardsS: `Välj från vår samling för att komma igång`,
suggestSet: `Föreslå set`,
createOwn: `Skapa din egen`,
search: `Sök`,
loading: `Läser in`,
words: `Ord`,
downloads: `Nedladdningar`,
export: `Exportera`,
import: `Importera`,
importing: `Importera ... Stäng inte appen`,
importPreview: `Importförhandsvisning`,
howQuizlet: `Hur man importerar från Quizlet`,
cards: `Kort`,
importPreviewStatus: `__ Villkor är redo att läggas till de befintliga ___ korten`,
importPaste: `Klistra in dina kort i ovanstående TextArea`,
setTotalLimitReached: `Du kan bara ha 3000 kort i en studyset`,
studying: `Studerar`,
learnt: `Lärt mig`,
mastered: `Behärskad`,
new: `Ny`,
noTerm: `Ingen term`,
noDef: `Ingen definition`,
cardSaved: `Kort sparat`,
reviews: `Recensioner`,
practices: `Praxis`,
flashcards: `Flashcards`,
alerts: `Varningar`,
corrects: `Korrigera`,
mistakes: `Misstag`,
reviewCycle: `Granskningscykel`,
reviewsLeft: `Recensioner kvar`,
lastReview: `Sista recension`,
nextReview: `Nästa recension`,
hideHistory: `Dölj full historia`,
showHistory: `Visa full historia`,
strength: `Styrka`,
star: `Stjärna`,
image: `Bild`,
tag: `Märka`,
added: `Lagt till`,
removed: `tog bort`,
reviewedFrom: `Granskad från __`,
notifications: `Meddelanden`,
reviewedPractice: `Granskad __ av ___ övning`,
successfully: `framgångsrikt`,
unsuccessfully: `utan framgång`,
termUpdated: `Term uppdaterad`,
defUpdated: `Definition uppdaterad`,
flashcardCreated: `Flashcard skapat`,
dropboxImage: `Du måste aktivera Dropbox Sync för att lägga till bilder`,
deleteImgConfirm: `Är du säker på att du vill ta bort den här bilden?`,
uploading: `Uppladdning`,
save: `Spara`,
uploadImageFail: `Det gick inte att ladda upp bilden`,
imageUploaded: `Bild laddas upp`,
setNotFound: `Studyset hittades inte!`,
notEnoughCards: `Inte tillräckligt med kort!`,
of: `__ av ___`,
on: `På`,
off: `Av`,
auto: `Automatisk`,
manual: `Manuell`,
pronounce: `Uttala`,
practiceCompleted: `Du har slutfört denna praxis`,
closePractice: `Nära träning`,
autoplay: `Autospela`,
secFlipSecNext: `__ Sec Flip, ___ sec Nästa`,
autopronounce: `Autopronounce`,
onlyTerm: `Enda term`,
onlyDef: `Endast definition`,
termAndDef: `Term och definition`,
savePractice: `Spara övning?`,
continueLater: `Fortsätt senare`,
deletePractice: `Ta bort praxis`,
term: `Termin`,
def: `Definition`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Granskningsmål`,
dailyGoal: `Dagliga mål`,
edit: `Redigera`,
setUp: `Uppstart`,
noRecentPractice: `Du har inga senaste metoder`,
continueLastReview: `Fortsätt sista recensionen`,
dueCards: `Förfallskort`,
studyNow: `Studera nu`,
newCards: `Nya kort`,
terms: `villkor`,
defs: `definitioner`,
validCardsOf: `Endast __ av de valda ___ -korten kan praktiseras, eftersom de andra antingen saknar termen eller definitionen`,
reviewCards: `Granskningskort`,
customizePractice: `Anpassa praxis`,
next: `Nästa`,
iWasRight: `jag hade rätt`,
printProAlert: `Köp Pro -prenumeration för att skriva ut mer än 20 flashcards`,
print: `Skriva ut`,
printWidth: `Term-def bredd`,
printFont: `Textstorlek`,
printBorder: `Gräns`,
printMargin: `Sidmarginal`,
printPadding: `Ordplockning`,
preparingFile: `Förberedande fil`,
notificationsBlocked: `Meddelanden är inte aktiverade, du aktiverar aviseringar från telefonens inställningar`,
ranOutOfWords: `Slut på kort, starta om övningen för att börja om`,
ranOutOfWordsShort: `Springa ut`,
ranOutOfWordsBody: `Öppna appen för att schemalägga nya ord`,
proIncreaseNotifications: `Du kan öka de totala aviseringarna från 10 till 50 i premiumversionen.`,
schedule: `Schema`,
frequency: `Frekvens`,
mode: `Läge`,
tM1: `1 minut`,
tM2: `2 minuter`,
tM5: `5 minuter`,
tM10: `10 minuter`,
tM15: `15 minuter`,
tM30: `30 minuter`,
tH1: `1 timme`,
tH2: `2 timmar`,
termPassive: `Terminspassiv`,
termActive: `Termin aktiv`,
defPassive: `Def passive`,
defActive: `Def aktiv`,
scheduledIn: `Schemalagd i __ min`,
scheduledAlertsProT: `Öka schemaläggbara varningar med proffs`,
scheduledAlertsProB: `Du kan öka de schemalagda varningarna från 10 till 50 med Pro -paketet`,
seeFeatures: `Se funktioner`,
defAndTerm: `Definition och term`,
termHoldDef: `Term, håll för att avslöja definition`,
defHoldTerm: `Definition, håll för att avslöja termen`,
notificationType: `Anmälningstyp`,
copyToClipboard: `Kopiera till urklipp`,
enterAuthCode: `Ange din auktoriseringskod`,
invalidCode: `Ogiltig kod tillhandahålls`,
copied: `Kopierad!`,
promoH2: `Flashcard manager pro`,
promoP: `Tryck för att upptäcka alla premiumfunktioner för att lära dig mer effektivt i din egen takt`,
promoBtn: `Upptäck alla funktioner`,
setDropboxH2: `Dropbox synkronisering`,
setDropboxPOff: `Aktivera Dropbox Sync för att hålla dina uppsättningar, flashcards, taggar och framsteg säkerhetskopierade och uppdaterade över alla dina enheter.`,
setDropboxPOn: `Dina data säkerhetskopieras och synkroniseras över dina enheter.`,
setDropboxBtn: `Synkronisera`,
status: `Status`,
syncNow: `Synkronisera nu`,
contact: `Kontakt`,
contactUs: `Kontakta oss`,
useFromBrowser: `Användning från webbläsaren`,
useFromBrowserMsg: `Besök flashcardsmadesimple.com på din dator och återställ dina kort och licens genom att aktivera Dropbox Sync`,
termsPrivacy: `Villkor och integritet`,
dailyReviewGoal: `Daglig granskningsmål`,
numberTerms: `Antal villkor`,
selectTerm: `Välj med termens tips`,
selectDef: `Välj med definitionstips`,
pronounceTerm: `Utteckna med termens tips`,
pronounceDef: `Uttalande med definitionstips`,
typeTerm: `Typ med termtryp`,
typeDef: `Typ med definitionstips`,
quizTypes: `Föredragna frågesporttyper`,
spacedRepetition: `Avstånd från repetitionsschema`,
spacedRepetitionP: `Avstånd från repetition kan du behärska ord med mindre ansträngningar genom att stegvis avstånd från granskningstiden. Standardschemat är 1-3-7-15-31 dagar, men du kan också ställa in en anpassad.`,
spacedRepetionScheduleItem: `__ dagar efter ___ recension (dag ____)`,
atLeastOneSchedule: `Minst ett schema krävs`,
revisionLimitReached: `Du nådde maximalt räkning`,
addReviewSchedule: `Lägg till nytt granskningsschema`,
autoMarkLearnt: `Auto Mark lärde sig efter`,
autoMarkMastered: `Auto Mark behärskas efter`,
tagManager: `Tagghanterare`,
delete: `Radera`,
addTag: `Lägg till ny tagg`,
tagDeletionH: `Taggning`,
tagDeletionP: `Är du säker på att du vill ta bort den här taggen?`,
cancel: `Avbryt`,
daysAfterLastReview: `Dagar efter den senaste recensionen`,
linkDropbox: `Länkdropbox`,
startSync: `Starta synkronisering`,
starred: `Medverkade`,
images: `Bilder`,
tags: `Taggar`,
types: `Typ`,
activeDays: `Aktiva dagar`,
inactiveDays: `Inaktiva dagar`,
longestStreak: `Längst`,
dailyGoalsCompleted: `Dagliga mål slutförda`,
dailyGoalsFailed: `Dagliga mål misslyckades`,
typePairs: `Typpar`,
reviewTypes: `Granskningstyper`,
typePractice: `Typpraxis`,
pronouncePractice: `Uttala praxis`,
selectPractice: `Välj övning`,
notificationReview: `Granskning av anmälan`,
flashcardReview: `Flashcard -granskning`,
studyset: `Studier`,
enterStudysetName: `Ange ett namn för din studyset`,
studysetName: `Ange Set's namn`,
termType: `Termtyp / lang`,
defType: `Definition typ / lang`,
exportCards: `Exportkort`,
importCards: `Importkort`,
quiz: `Frågesport`,
showingOutOfCards: `Visar __ av ___ kort`,
showingAllCards: `Visar alla kort, skriv in i ovanstående sökfält eller tryck på alla taggar för att filtrera`,
recording: `Inspelning`,
downloadSet: `Lägg till mina uppsättningar`,
addNewCard: `Lägg till nytt kort`,
saveStudyset: `Spara studieuppsättning`,
studysetDeletionH: `Studyset -borttagning`,
studysetDeletionP: `Är du säker på att du vill ta bort den här studyset, detta kommer också att ta bort alla innehållande kort.`,
cardDeletionH: `Kortradering`,
cardDeletionP: `Är du säker på att du vill ta bort det här kortet`,
cardLimitReached: `Du kan bara ha 3000 kort i en studyset`,
limitExceeded: `Gräns ​​överskriden`,
atLeastTenCards: `Lägg till minst 10 kort för att komma igång med praxis`,
searchInAll: `Sök i alla studieuppsättningar`,
noMatch: `Ingen match`,
atLeastThreeChars: `Ange minst 3 tecken för att söka`,
noSets: `Inga uppsättningar`,
startingSync: `Startsynkronisering`,
noSetsP: `Välj från alternativen nedan för att komma igång`,
startingSyncP: `Vi får dina data från Dropbox, det kan ta ett tag`,
createNewStudyset: `Skapa nya studier`,
restoreFromBackup: `Återställ från säkerhetskopieringsfilen`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Välj träningstyp`,
noDueCards: `Inga förfallna flashcards ännu, flashcards som du har granskat tidigare kommer att börja dyka upp här efter det valda avståndsupprepningsschemat för att hjälpa dig behärska ord med mindre ansträngning och tid`,
noNewCards: `Inga nya kort att studera`,
subscriptionH: `Köp Pro för att njuta av alla funktioner och för att stödja den kontinuerliga utvecklingen.`,
buyLifetimePro: `Köp Lifetime Pro för __`,
restorePurchase: `ÅTERSTÄLLA INKÖP`,
termsPrivacyC: `Villkor och integritetspolicy`,
licenceShare: `Om du köpte en licens från en annan enhet kan du dela den med den här enheten genom att aktivera Dropbox Sync på båda enheterna`,
enterTagName: `Ange namnet på taggen`,
invalidName: `Ogiltigt namn`,
create: `Skapa`,
name: `namn`,
tagName: `Namn på din tagg`,
color: `Färg`,
back: `Tillbaka`,
rowSeparator: `Radavskiljare`,
termDefSeparator: `Term - def separator`,
output: `Produktion`,
inputCards: `Inmatningskort`,
review: `Recension`,
language: `Språk`,
archiveReversible: `Arkiv (reversibelt från inställningar)`,
deletePermanent: `Ta bort (irreversibel)`,
archivedCards: `Arkiverade kort`,
masteredCards: `Behärskade kort`,
due: `På grund av`,
reviewed: `Recenserad`,
markReviewed: `Mark Reviewed`,
markMastered: `Mark Mastered`,
forXYCards: `för __ ___ kort`,
createdAtSortBy: `Skapelsedagen`,
lastReviewedSortBy: `Senaste granskningsdatum`,
reviewCountSortBy: `Antal recensioner`,
strengthSortBy: `Styrka`,
termSortBy: `Alfabetisk term`,
definitionSortBy: `Alfabetisk def.`,
ascSortBy: `Stigande`,
descSortBy: `Nedåtgående`,
featureSync: `Studera vad som helst, var som helst, när som helst med dina flashcards synkroniserade över alla dina enheter`,
featureSpacedrepetition: `Titta på dina övergripande framsteg och komma tillbaka till att öva på det du behöver för att öva`,
featureNotifications: `Supercharge ditt lärande utan att ens öppna appen med flexibla aviseringar`,
featureFlashcards: `Autoplay flashcards när dina händer eller ögon är upptagna, men du har fortfarande oanvänd uppmärksamhet`,
featureQuiz: `Matcha, stava ut, lyssna eller välj för att öva på dina flashcards`,
featureStats: `Få bättre inblick i dina kort och resultat och sök över alla dina flashcard -uppsättningar`,
featureImport: `Vi kommer aldrig att lagra några uppgifter om dig, och du kan enkelt exportera och importera alla dina data`,
featurePrint: `Få lite inlärning genom att skriva ut dina flashcards och DIY din egen studierigg`,
splashIntro: `Studera alla dina flashcards var som helst i din takt och stil`,
selectSortOrder: `Sorteringsordning`,
selectSortProp: `Sortera egendom`,
applyFilters: `Använd filter`,
selectSetType: `Vad vill du öva?`,
getStarted: `Komma igång`,
tapToUnarchive: `Tryck på de kort du vill oarkivera`,
untitled: `Ofrälse`,
sortHintNew: `Du kommer att se korten som skapades för längsta tid sedan först`,
sortHintDue: `Du kommer att se kort som har varit förfallna för den längsta första`,
sortHintOther: `Du kommer att se kort som inte har studerats den längsta först`,
flashcardsWhen: `, när dina händer eller ögon är upptagna, även när du lyssnar på musik / podcast`,
notificationsWhen: `, för när du är ute och bara vill ha snabba studiebitar`,
quizWhen: `, för när du kan ägna full uppmärksamhet för att studera, för att behärska dina kort`,
features: `Funktioner`,
ratings: `Betyg`,
notificationDailyCatchUpBody: `Nytt: __, förfaller: ___, studerar: ____, lärt sig: _____, behärskad: ______`,
notificationDailyCatchUpTitle: `Daglig catchup`,
reviewedJN: `Granskad just nu`,
customUpdated: `Anpassad text uppdaterad`,
customTextField: `Synonymer, exempel etc.`,
field: `Fält`,
link: `Länk`,
backToParentCard: `Tillbaka till moderkortet`,
discard: `Kassera`,
failedImageLoad: `Det gick inte att ladda bilden, se till att du är ansluten till Internet`,
printDIYLabel: `DIY ditt eget kreativa pappersbaserade studieinställning, dela med oss ​​din skapelse och bli med i appen.`,
reviewGraphChart: `Granskningsfrekvens`,
langNotSet: `Språket är inte inställt`,
pronouncationLangInfo: `För att aktivera uttal måste du välja termen och definitionsspråket. Ett högtalarskylt visas bredvid språken om din enhet stöder det språket`,
clearFilters: `Rensa filtret`,
subFreeUnlimited: `Obegränsade studyset, flashcards, praxis, sökning och synkronisering`,
customFields: `Anpassade fält`,
subLinks: `Kortlänkar`,
subPrint: `Tryck / studset`,
subNotifications: `Meddelande innan du måste öppna appen`,
subCardsStudysets: `Kort / studyset`,
subRevisionCycles: `Anpassade revisionscykler`,
subscriptionHEnd: `Uppgradering till Pro visar oss att du tycker att vårt hårda arbete är värdefulla och ger oss uppmuntran och kaffe för att fortsätta förbättra och skapa nya fantastiska saker.`,
subFree: `Fri`,
subPro: `Proffs`,
guideSpacedRepetition: `Hur fungerar avståndsupprepning och övningstyper`,
guideSearch: `Sökning och filtrering`,
guideSync: `Aktivera säkerhetskopiering och synkronisera över dina enheter`,
guidePronunciation: `Aktivera uttal`,
guideImport: `Importera kort från att lämna källor`,
guideAccess: `Vem har tillgång till mina data?`,
guideData: `Vilka data samlar vi in?`,
guideContact: `Behöver du hjälp med något annat? Skriv till oss`,
arrowStrength: `Ställ in hur väl du känner till det här kortet`,
arrowImage: `Lägg till bilder`,
arrowField: `Lägg till ytterligare anpassade textfält`,
arrowTag: `Bifoga taggar`,
arrowStar: `Mark som favorit`,
arrowLink: `Länk till andra kort`,
arrowGoal: `Ställ in ett dagligt granskningsmål för dig själv`,
arrowDue: `Studera ord som kommer att granskas`,
arrowNew: `Studiekort som inte har granskats än`,
arrowMastered: `Om du inte har några förfallna eller nya kort kan du granska Mastered Cards för att hålla dem behärskade`,
arrowImport: `Importera dina befintliga flashcards`,
arrowNewCard: `Lägg till ett nytt flashcards`,
dropboxStep1: `1. Få åtkomstkod från Dropbox genom att logga in`,
dropboxStep1Btn: `Logga in med Dropbox`,
dropboxStep2: `2. Ange åtkomstkod nedan`,
dropboxStep2Input: `Skriv koden här`,
dropboxStep3: `3. Börja synkronisera`,
alreadyLinked: `Redan länkad, tryck för att lossa`,
selectCardsToLink: `Välj kort att länka`,
unsupportedLangP: `Välj ett språk som stöder uttalande från setens inställningar`,
links: `Länkar`,
emailUs: `Skicka oss ett e-mail`,
whatsappUs: `Whatsapp oss`,
printMinHeight: `Min. Radhöjd`,
exportType: `Exportfiltyp`,
generateFileText: `Generera fil`,
generatatingFile: `Genereringsfil`,
verySmall: `Väldigt liten`,
small: `Små`,
normal: `Vanligt`,
big: `Stor`,
veryBig: `Väldigt stor`,
repeatNTimes: `Upprepa __ gånger`,
pause: `Paus`,
for: `för`,
say: `Säga`,
defShort: `Defin.`,
times: `Times`,
autoplayPreferences: `Ställ in autoplainpreferenser`,
autoPlay1: `Paus efter föregående ord`,
autoPlay2: `Antal terminsuttalande`,
autoPlay3: `Paus innan du avslöjar definitionen`,
autoPlay4: `Antal definitionsuttalande`,
autoPlay5: `Paus innan du visar nästa ord`,
autoPlay6: `Upprepa samma flashcard`,
startAutoPlay: `Starta autoplay`,
autoPlayOffConfirm: `Stäng av autoplay för att aktivera manuella kontroller`,
turnOff: `Stäng av`,
keepPn: `Fortsätt`,
foundIn: `Hittades i __`,
repeat: `upprepa`,
stop: `Sluta`,
listenInBreak: `Visste du? Du kan lyssna på musik / podcast i pauser`,
contextSearch: `Sammanhangssökning`,
contextSearchText: `Få exempel på hur __ används i olika meningar`,
transalteSearch: `Översätt`,
translateSearchText: `Översätt till ___`,
synonymSearch: `Synonym sökning`,
synonymSearchText: `Sök efter synonymer av __`,
selectToAdd: `Välj de resultat du vill lägga till i det här kortet`,
addToCard: `Lägg till vald till kortet`,
hideFromPractice: `Göm i rundan`,
setLanguageRequired: `Välj språket i villkoren och definitionerna i studysetdetaljerna`,
fieldNeedsText: `Ange något i detta fält innan du söker`,
possibleDupe: `Möjlig duplikat`,
loadNextXCards: `Ladda nästa __ -kort`,
repeatPractice: `Upprepa dessa __ -kort`,
keepScreenOnInfo: `Du kanske måste justera din auto-låsinställning för att hålla skärmen på medan du är automatisk.`,
siteLoginH2: `SFM -konto`,
siteLoginP: `Du kan använda dina flashcards tillverkade enkla konto för att dela dina flashcards med dina vänner, dina elever eller hela samhället.`,
logOut: `Logga ut`,
logIn: `Logga in`,
createAccount: `Skapa nytt konto`,
signUp: `Bli Medlem`,
username: `Användarnamn`,
email: `E-post`,
password: `Lösenord`,
networkError: `Nätverksfel`,
fillAllDetails: `Fyll i alla detaljer`,
noUserWithDetails: `Ingen användare hittades med de angivna detaljerna`,
userAlreadyExists: `Det angivna e -postmeddelandet eller användarnamnet finns redan`,
signUpOrLoginToCont: `Registrera dig eller logga in för att fortsätta?`,
atLeastOneCardToShare: `Minst ett kort krävs för att dela`,
publishingStudyset: `Publiceringsstudyset`,
updatesDetected: `Uppdateringar upptäckta, vill du fortsätta uppdatera lokala data? (Raderad: __, uppdaterad: ___, ny: ____)`,
updatesApplied: `Uppdateringar tillämpas`,
alreadyUpToDate: `Redan uppdaterad`,
practiceTypeArrow: `Upptäck olika sätt att praportera`,
share: `Dela med sig`,
sharingModalIntro: `Dela dina flashcards i den här uppsättningen med dina vänner, dina elever eller hela samhället.`,
whatIsShared: `Vad delas`,
whatIsNotShared: `Vad som inte delas`,
whatIsSharedText: `Ställ in namn, ange terminsspråk, definitonspråk, alla inkluderade kort med termer, definitioner, anpassade textfält och bilder`,
whatIsNotSharedText: `Alla kortstyrkor, stjärnor, länkar, taggar och din granskningshistorik`,
checkForSharedUpdates: `Kontrollera om det finns uppdateringar från skaparen`,
fetchUpdates: `Hämta uppdateringar`,
youSharedStudyset: `Du delade denna studyset`,
publishChanges: `Spara och publicera ändringar`,
redeem: `Lösa in`,
noAds: `Inga annonser`,
dupeDetection: `Duplicerad detektion`,
coffeeFeature: `Kaffe, för att hjälpa oss att utveckla fler funktioner`,
shareLink: `Dela länk`,
coffeeForUs: `Du kommer att få en livstidslicens för endast __, vilket ger Emily 6 -kaffe, Dominik 3 -kaffe och Russ 3 -kaffe, vilket kommer att driva oss i cirka 39 timmar för att göra detta apphändelse bättre`,
sharingCards: `Delningskort`,
published: `Publicerad`,
alreadyHaveAccount: `Har du redan ett konto?`,
notAlreadyHaveAccount: `Har du inte ett konto än?`,
startPractice: `Börja träna`,
selectQuizTypes: `Välj frågesporttyper`,
correct: `Korrekt`,
incorrect: `Felaktig`,
yes: `Ja`,
no: `Nej`,
levelSilver: `Silvernivå __`,
levelGold: `Guldnivå __`,
levelPlatinum: `Platina nivå __`,
levelDiamond: `Diamantnivå __`,
levelJade: `Jadenivå __`,
reviewsLeftGoal: `__ Recensioner för det dagliga målet`,
dailyGoalAchieved: `Dagligt mål uppnåtts`,
share: `Dela med sig`,
rateApp: `Betygsätt app`,
allStats: `All statistik`,
reviewTimeError: `Timeout efter fel`,
reviewTimeCorrect: `Timeout efter korrekt`,
pronounceTermAfterReview: `Uttalande term efter granskning`,
pronounceDefinitionAfterReview: `Uttalande definition efter granskning`,
practice: `Öva`,
notificationsScheduledInfo: `__ Meddelanden har planerats, du kan stänga appen nu`,
wellDone: `Bra gjort`,
keepItUp: `Fortsätt så`,
youRock: `Du äger`,
niceOne: `Snyggt`,
lnSelect: `Välj språk`,
sampleData: `Inga recensioner som visar provdata`,
reviewFreq: `Granskningsfrekvens`,
selectPractice: `Övning: Välj`,
spellPractice: `Övning: Stava`,
connectPractice: `Övning: Anslut`,
languages: `språk`,
languagesPairs: `Språkpar`,
shareArrow: `Dela med vänner, studenter eller hela samhället`,
cardsPerRound: `Kort / runda`,
showAll: `Visa allt`,
supportedLangsVary: `Stödda språk varierar`,
practiceWithoutSave: `Öva inte sparad`,
practiceWithoutSaveBody: `Du har inte lagt till den här studyseten i din samling, vill du lägga till den nu för att spara din studieframsteg?`,
saveSetNow: `Spara kort till din samling`,
continueWithoutSaveSave: `Börja träna utan spara`,
createdBy: `Skapad av`,
setSavedToYourCollection: `Studieuppsättning sparad i din samling`,
accountBackupDisclaimer: `Observera att det här kontot endast kan användas för att dela studier med andra och inte kan användas för att säkerhetskopiera eller synkronisera dina studier eller flashcards. För att synkronisera och säkerhetskopiera alla dina data, använd Dropbox Sync`,
syncEnabled: `Synkronisering aktiverad och hämtar ditt innehåll pågår`,
searchAllSets: `Sökstudieuppsättningar från andra användare`,
anyLanguage: `Vilket språk som helst`,
trendingIn: `Trendig i`,
manualBackups: `Backup`,
manualBackupCreate: `Skapa manuell säkerhetskopia`,
confirmManualImport: `Är du säker på att du vill byta ut all aktuell data med denna säkerhetskopia? Detta rekommenderas bara på nya enheter utan data`,
importFromManualBackup: `Importera från säkerhetskopiering`,
imgOfflineSets: `Auto-nedladdningsbilder för offline-lärande`,
unsupportedDeviceCache: `Den här funktionen är endast tillgänglig från iOS eller Android -appen`,
shareChanges: `Dela __ förändringar`,
publiclySearchable: `Sökbar av användare`,
description: `Beskrivning`,
restoreFromDropboxBackup: `Återställ från Dropbox Backup`,
imageCacheStudysetSub: `[Endast iOS & Android] Ladda ner bild för offline -studier`,
keywordsOrLangNeeded: `Du måste ange några nyckelord eller ett språk`,
dropboxAlreadyLinked: `Dropbox -konto är redan länkat`,
noSetUpdateAccess: `Du har inte tillgång till att redigera denna studieuppsättning.`,
confirmSetOwnerLogin: `Om du är säker på att du är ägaren kan du försöka logga in på ditt konto igen.`,
uninitedRestriction: `För att spara dina framsteg måste du först lägga till denna studyset i din samling`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Det gick inte att konsolidera lagring`,
consolidateStorageDone: `Lagring Konsolidera, vänligen tillåt upp till en timme för Dropbox för att avsluta bort gamla filer innan du loggar in på en ny enhet.`,
consolidatingStorage: `Konsolidering av lagring ...`,
deleteAccount: `Radera konto`,
consolidateStorageDescription: `Den här operationen kommer att återinföra dina säkerhetskopieringsfiler, så att ställa in en ny enhet kommer att vara snabbare`,
consolidatingStorageConfirm: `Se till att alla dina ändringar redan har slutfört synkronisering, inte synkronisera andra enheter medan denna process äger rum. Vill du fortsätta?`,
consolidateStorage: `Konsolidera lagring`,


}